import { cn } from "@/lib/utils"
import type { InputHTMLAttributes, Ref } from "react"

type InputProps = InputHTMLAttributes<HTMLInputElement> & {
  ref?: Ref<HTMLInputElement>
}

function Input({ className, ref, ...props }: InputProps) {
  return (
    <input
      ref={ref}
      className={cn(
        "w-full rounded-[var(--radius-sm)] border border-[var(--color-rule-strong)] bg-[var(--color-paper-high)] px-4 py-3 text-base sm:text-[0.95rem] text-[var(--color-ink)] outline-none transition-colors placeholder:text-[var(--color-ink-soft)] hover:border-[var(--color-ink-soft)] focus:border-[var(--color-vermilion)] focus:shadow-[0_0_0_3px_var(--color-rule-strong)] disabled:cursor-not-allowed disabled:opacity-60 aria-invalid:border-[var(--color-vermilion)]",
        className
      )}
      {...props}
    />
  )
}

export { Input }
